if (!customElements.get('wlsn-sticky-bar')) {
    class WLSNStickyBar extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                active: 'active'
            };

            this.checkVisibility = this.checkVisibility.bind(this);
        }

        connectedCallback() {
            window.addEventListener('scroll', this.checkVisibility);
            this.checkVisibility();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.checkVisibility);
        }

        checkVisibility() {
            let shouldHide = false;
            const hideOnSectionIds = this.getAttribute('data-hide-on-section-ids');
            
            if (hideOnSectionIds) {
                const sectionIds = hideOnSectionIds.split(',').map(id => id.trim());
                
                sectionIds.forEach((sectionId) => {
                    const section = document.getElementById(sectionId);
                    if (section) {
                        const rect = section.getBoundingClientRect();
                        
                        // Check if section is in view (top is above bottom of viewport and bottom is below top of viewport)
                        if (rect.top < window.innerHeight && rect.bottom > 0) {
                            shouldHide = true;
                        }
                    }
                });
            }

            if (shouldHide) {
                this.classList.remove(this.classes.active);
            } else {
                this.classList.add(this.classes.active);
            }
        }
    }

    customElements.define('wlsn-sticky-bar', WLSNStickyBar);
}
